import * as React from "react";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { useInfiniteLoader } from "react-window-infinite-loader";
import styled from "styled-components";
import { WindowList } from "components/common/Select/CustomMenuList";
const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 100%;
`;
const NoOptionsMessage = () => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(StyledDiv, { className: "menu-notice menu-notice--no-options" }, t("select.no_options"));
};
const AsyncCustomMenuList = ({
  children,
  selectProps: { loadOptions, total }
}) => {
  const items = (children == null ? void 0 : children.length) ? children : [/* @__PURE__ */ React.createElement(NoOptionsMessage, { key: "noOptions" })];
  const listRef = useRef(null);
  const onRowsRendered = useInfiniteLoader({
    isRowLoaded: (index) => index < children.length,
    rowCount: total,
    threshold: 30,
    minimumBatchSize: 50,
    loadMoreRows: loadOptions
  });
  return /* @__PURE__ */ React.createElement(WindowList, { listRef, onRowsRendered }, items);
};
export default AsyncCustomMenuList;
